import { motion } from 'framer-motion';

const props = [
  {
    icon: (
      <svg aria-hidden="true" className="w-8 h-8 text-sage" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    title: 'Under-taught, not broken',
    description:
      "If money feels confusing, you're not failing. You're navigating a high-stakes system that's been deliberately obscured by jargon, built on the assumption you should already know how it works. This book pulls the curtain back on what lenders, landlords, and financial institutions are actually reading when they look at your file.",
  },
  {
    icon: (
      <svg aria-hidden="true" className="w-8 h-8 text-sage" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
      </svg>
    ),
    title: 'A plan, not a punishment',
    description:
      "Most money advice fails because it's built for a version of you that doesn't exist: the one who never gets tired, never eats out, never has a heavy week. You'll build a budget that survives a Tuesday in the real world, and a debt payoff plan you can actually stick to.",
  },
  {
    icon: (
      <svg aria-hidden="true" className="w-8 h-8 text-sage" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
      </svg>
    ),
    title: 'Slow is not stuck',
    description:
      "You don't need a personality transplant, a thirty-category spreadsheet, or a perfect month. You need a calmer system, one you can come back to, and enough momentum to start moving in the right direction. If your progress feels boring, that usually means you're winning.",
  },
];

export function ValueProps() {
  return (
    <section className="py-20 sm:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-text">
            A different kind of money book
          </h2>
          <p className="mt-4 text-text-light text-lg max-w-2xl mx-auto">
            Not a hustle guide. Not a get-rich-quick pitch. A clear, honest walk-through
            of how this stuff actually works, and how to stop feeling behind.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {props.map((prop, i) => (
            <motion.div
              key={prop.title}
              className="p-8 rounded-xl bg-bg border-l-4 border-sage hover:shadow-lg transition-shadow"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
            >
              <div className="mb-4">{prop.icon}</div>
              <h3 className="font-serif text-xl font-semibold text-text mb-3">{prop.title}</h3>
              <p className="text-text-light leading-relaxed">{prop.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
